/**
 * The league chip row's reveal rule (ISSUE-949 R9). The active chip must be
 * fully visible, and a chip that already is must not move. Pure, so the
 * geometry is tested without a browser.
 */
export type typeRevealGeometry = {
  /** The scroller's scrollLeft right now. */
  scrollLeft: number;
  /** The scroller's visible box, from its own getBoundingClientRect(). */
  rowLeft: number;
  rowRight: number;
  /** The active chip's box, from its own getBoundingClientRect(). */
  chipLeft: number;
  chipRight: number;
};

export function scrollLeftToRevealChip(geometry: typeRevealGeometry): number {
  const { scrollLeft, rowLeft, rowRight, chipLeft, chipRight } = geometry;

  if (chipLeft >= rowLeft && chipRight <= rowRight) {
    return scrollLeft;
  }

  if (chipLeft < rowLeft) {
    return Math.max(0, scrollLeft - (rowLeft - chipLeft));
  }

  const rowWidth = rowRight - rowLeft;
  const chipWidth = chipRight - chipLeft;
  if (chipWidth > rowWidth) {
    return Math.max(0, scrollLeft + (chipLeft - rowLeft));
  }
  return scrollLeft + (chipRight - rowRight);
}
